import { SEO } from '@/components/SEO';
import Header from '@/components/Header';
import Hero from '@/components/Hero';
import FeaturedProducts from '@/components/FeaturedProducts';
import AboutSection from '@/components/AboutSection';
import Testimonials from '@/components/Testimonials';
import CTASection from '@/components/CTASection';
import Footer from '@/components/Footer';
import useSections from '@/hooks/useSections';

const Index = () => {
  const { data: sections } = useSections('index');

  const renderSection = (section: any) => {
    switch (section.key) {
      case 'hero':
        return <Hero key={section.$id} {...section} />;
      case 'featured':
        return <FeaturedProducts key={section.$id} {...section} />;
      case 'about':
        return <AboutSection key={section.$id} {...section} />;
      case 'testimonials':
        return <Testimonials key={section.$id} {...section} />;
      case 'cta':
        return <CTASection key={section.$id} {...section} />;
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <SEO url="/" />
      <Header />
      <main>
        {sections ? (
          sections.map(renderSection)
        ) : (
          <>
            <Hero />
            <FeaturedProducts />
            <AboutSection />
            <Testimonials />
            <CTASection />
          </>
        )}
      </main>
      <Footer />
    </div>
  );
};

export default Index;
